import { createContext, useContext } from "react";
import { createTranslator, pickLocale, type Locale, type TFunction } from "@heylife/i18n";

export const I18nContext = createContext<{ locale: Locale; t: TFunction }>({
  locale: "de",
  t: createTranslator("de").t,
});

export function useT() {
  return useContext(I18nContext);
}

export function detectLocale(): Locale {
  const stored = localStorage.getItem("heylife.locale");
  if (stored === "de" || stored === "en") return stored;
  return pickLocale(navigator.language);
}
